import Popup from "../lib/Popup";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import { IGameSnacks } from "../lib/GameSnacks";
import ServiceLocator from "../ServiceLocator";
import Button from "../lib/Button";
import { Profile } from "../lib/game_snacks/IUser";
import Session, { game_type } from "../Session";
import { LiveEventData, LiveEventDataType, LivePlayerDataEvent, LivePresenceAction, LiveRoomData } from "../lib/game_snacks/ILiveMultiplayer";
import { Signal } from "signals";
import PRNG from "../lib/PRNG";
import Settings from "./Settings";
import Utils from "../Utils";
import PlayerSlot from "./popup/PlayerSlot";
import TutorialPopup from "./popup/TutorialPopup";
import Screen from "../lib/Screen";
import { screen_type } from "../state/GameState";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class FakeMatchMakingScreen extends Screen
{
    // #region Attributes //

    // private:

    private _gameStartedBg: PIXI.Sprite = null;
    private _innerLoadingCircle: PIXI.Sprite = null;
    private _outerLoadingCircle: PIXI.Sprite = null;
    private _versus: PIXI.Sprite = null;
    private _versusExplosion: PIXI.Sprite = null;
    private _headerText: PIXI.Text = null;
    private _footerText: PIXI.Text = null;
    private _arrPlayerSlot: Array<PlayerSlot> = null;
    private _settings: Settings = null;
    private _fadeOutBg: PIXI.Graphics = null;

    private _autoStartTimer: number = null;

    private _loadingCircleTimeline: gsap.core.Timeline = null;
    private _gameReadyTl: gsap.core.Timeline = null;

    private _arrBotNames: Array<string> = null;
    private _arrBotAvatarIndex: Array<number> = null;
    private _isGameStarted: boolean = null;

    // #endregion //


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        Session.i.gameType = game_type.CLASSIC_MATCHMAKING;

        this._arrPlayerSlot = [];
        this._isGameStarted = false;

        this._arrBotNames = Utils.generateBotNames( 1 );
        //                
        this._arrBotAvatarIndex = [];
        while ( this._arrBotAvatarIndex.length < 1 )
        {
            const kBotAvatarIndex: number = Math.floor( Math.random() * 12 );
            if ( !this._arrBotAvatarIndex.includes( kBotAvatarIndex ) )
            {
                this._arrBotAvatarIndex.push( kBotAvatarIndex );
            }
        }

        let bg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.matchmaking_background_01.texture );
        bg.anchor.set( 0.5 );
        bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( bg );

        this._gameStartedBg = new PIXI.Sprite( ServiceLocator.resources.matchmaking_background_02.texture );
        this._gameStartedBg.visible = false;
        this._gameStartedBg.anchor.set( 0.5 );
        this._gameStartedBg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( this._gameStartedBg );

        this._versusExplosion = new PIXI.Sprite( ServiceLocator.resources.vs_background_effect.texture );
        this._versusExplosion.visible = false;
        this._versusExplosion.anchor.set( 0.5 );
        this._versusExplosion.position.set( ServiceLocator.app.width * 0.5, 619 );
        this._root.addChild( this._versusExplosion );

        this._headerText = new PIXI.Text( "Play Online", { fontFamily: "jaro_regular", fontSize: 80, fill: 0xffffff, stroke: 0x000000, strokeThickness: 12, letterSpacing: 2 } );
        this._headerText.anchor.set( 0.5 );
        //this._headerText.position.set( ServiceLocator.app.width * 0.5, 158 );
        this._headerText.position.set( ServiceLocator.app.width * 0.5, 318 );
        this._root.addChild( this._headerText );

        /*let gameModeText: PIXI.Text = new PIXI.Text( "Selected game mode:", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        gameModeText.anchor.set( 0.5 );
        gameModeText.position.set( ServiceLocator.app.width * 0.5, 270 );
        this._root.addChild( gameModeText );

        let gameModeIcon: PIXI.Sprite = new PIXI.Sprite( Session.i.gameType == game_type.CLASSIC_MATCHMAKING ? ServiceLocator.resources.button_mode_classic.texture : ServiceLocator.resources.button_mode_301.texture );
        gameModeIcon.anchor.set( 0.5 );
        gameModeIcon.position.set( ServiceLocator.app.width * 0.5, 366 );
        this._root.addChild( gameModeIcon );*/

        const kArrPos: Array<PIXI.Point> = [ 
            new PIXI.Point( 158, 614 ),
            new PIXI.Point( ServiceLocator.app.width - 158, 614 ) ];
        for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
        {
            let playerSlot: PlayerSlot = new PlayerSlot( ServiceLocator.resources.matchmaking_avatar_base.texture );
            playerSlot.position.copyFrom( kArrPos[ i ] );
            this._root.addChild( playerSlot );            
            //
            this._arrPlayerSlot.push( playerSlot );
        }
        this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile );

        this._versus = new PIXI.Sprite( ServiceLocator.resources.vs.texture );
        this._versus.visible = false;
        this._versus.anchor.set( 0.5 );
        this._versus.position.set( ServiceLocator.app.width * 0.5 + 8, 605 );
        this._root.addChild( this._versus );

        /*this._backBtn = new Button( { on: "button_back", pressed: "button_back_pressed" } );
        this._backBtn.anchor.set( 0.5 );
        this._backBtn.position.set( 58 );
        this._root.addChild( this._backBtn );
        this._backBtn.on( "pointertap", () => { 
            this._root.interactiveChildren = false;
            if ( window.GameSnacks )
            {
                window.GameSnacks.liveMultiplayer.updatePlayerPresence( LivePresenceAction.LEAVE )
                    .then( () => {
                        this._onClosed.dispatch( this ); 
                    } );
            }
            else
            {
                this._onClosed.dispatch( this ); 
            }
        } );*/

        this._footerText = new PIXI.Text( "Looking for opponent...", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        this._footerText.anchor.set( 0.5 );
        this._footerText.position.set( ServiceLocator.app.width * 0.5, 900 );
        this._root.addChild( this._footerText );

        this._innerLoadingCircle = new PIXI.Sprite( ServiceLocator.resources.loading_circle_int.texture );
        this._innerLoadingCircle.scale.set( 0.4 );
        this._innerLoadingCircle.anchor.set( 0.5 );
        this._innerLoadingCircle.position.copyFrom( this._arrPlayerSlot[ 1 ].position );
        this._innerLoadingCircle.y += this._arrPlayerSlot[ 1 ].height * 0.5 + 4;
        this._root.addChild( this._innerLoadingCircle );
        //
        this._outerLoadingCircle = new PIXI.Sprite( ServiceLocator.resources.loading_circle_ext.texture );
        this._outerLoadingCircle.scale.set( 0.4 );
        this._outerLoadingCircle.anchor.set( 0.5 );
        this._outerLoadingCircle.position.copyFrom( this._innerLoadingCircle.position );
        this._root.addChild( this._outerLoadingCircle );
        //
        this._loadingCircleTimeline = new gsap.core.Timeline();
        this._loadingCircleTimeline.to( this._innerLoadingCircle, { angle: -360, repeat: -1, duration: 6, ease: "linear.inOut" }, 0 );
        this._loadingCircleTimeline.to( this._outerLoadingCircle, { angle: 360, repeat: -1, duration: 6, ease: "linear.inOut" }, 0 );

        this._settings = new Settings();
        this._settings.init( true );
        this._settings.position.set( 592, 7 + 16 );
        this._root.addChild( this._settings );
        this._settings.onTutorial.add( () => { 
            let tutorialPopup: TutorialPopup = new TutorialPopup();
            tutorialPopup.init();
            this._root.addChild( tutorialPopup );
            tutorialPopup.onClosed.add( ( popup: TutorialPopup ) => {
                popup.end();
            } );
        } );
        this._settings.onHome.addOnce( () => {
            this._onCompleted.dispatch( screen_type.LOBBY ); 
        } );
        
        this._fadeOutBg = new PIXI.Graphics();
        this._fadeOutBg.position.set( -ServiceLocator.app.safeAreaMarginX, -ServiceLocator.app.safeAreaMarginY );
        this._fadeOutBg.beginFill( 0x000000 );
        this._fadeOutBg.drawRect( 0, 0, ServiceLocator.app.safeAreaWidth, ServiceLocator.app.safeAreaHeight );
        this._fadeOutBg.endFill();
        this._root.addChild( this._fadeOutBg );
        this._fadeOutBg.visible = false,
        this._fadeOutBg.alpha = 0;

        Session.i.room = [ Session.i.profile ];
        this._updateOtherPlayerSlots();

        ServiceLocator.multiplayerEventManager.onProfileChange.add( this._onProfile_Changed, this );
    }

        private _updateOtherPlayerSlots(): void
        {
            for ( let i: number = 1; i < Session.i.kGameRoomSize; ++i )
            {
                this._arrPlayerSlot[ i ].empty();
            }

            let myProfileIndex: number = 0;
            while ( Session.i.room[ myProfileIndex ].uid != Session.i.profile.uid )
            {
                myProfileIndex += 1;
            }

            let playerCount: number = 1;
            let playerProfileIndex: number = myProfileIndex + 1;
            if ( playerProfileIndex > Session.i.room.length - 1 )
            {
                playerProfileIndex = 0;
            }
            let playerSlotIndex: number = 1;
            //
            while ( playerCount < Session.i.room.length )
            {
                this._arrPlayerSlot[ playerSlotIndex ].setPlayer( Session.i.room[ playerProfileIndex ] );

                playerProfileIndex += 1;
                if ( playerProfileIndex > Session.i.room.length - 1 )
                {
                    playerProfileIndex = 0;
                }
                playerSlotIndex += 1;

                playerCount += 1;
            }
        }

        private _onProfile_Changed( profile: Profile): void
        {
            ( Session.i.profile.avatar as any ) = profile.avatar;
            ( Session.i.profile.username as any ) = profile.username;
            Session.i.profile.isFake = false;

            this._arrPlayerSlot[ 0 ].setPlayer( Session.i.profile )
        }

    public onLeave(): void
    {
        ServiceLocator.multiplayerEventManager.onProfileChange.remove( this._onProfile_Changed, this );

        if ( this._loadingCircleTimeline )
        {
            this._loadingCircleTimeline.kill();
            this._loadingCircleTimeline = null;
        }

        if ( this._gameReadyTl )
        {
            this._gameReadyTl.kill();
            this._gameReadyTl = null;
        }

        this._settings.end();
        this._settings = null;

        super.onLeave();
    }

    public onUpdate( dt: number ): void
    {
        if ( this._isGameStarted ) { return; }

        if ( Session.i.room.length > 0
            && Session.i.room.length <= Session.i.kGameRoomSize )
        {
            this._autoStartTimer += dt;
            if ( this._autoStartTimer > 3 ) 
            {
                this._isGameStarted = true;

                this._addBot();
                this._updateOtherPlayerSlots();

                Session.i.prng = new PRNG( Math.floor( Math.random() * 9999 ) );

                if ( this._loadingCircleTimeline )
                {
                    this._loadingCircleTimeline.kill();
                    this._loadingCircleTimeline = null;
                }
                this._innerLoadingCircle.visible = false;
                this._outerLoadingCircle.visible = false;
                //
                this._settings.interactive = false;
                gsap.to( this._settings, { alpha: 0, duration: 0.4, ease: "linear.inOut" } );

                for ( let i: number = 0; i < Session.i.kGameRoomSize; ++i )
                {
                    Session.i.room[ i ].dartSkinIndex = 0;
                }

                this._footerText.text = Session.i.room[ 1 ].username.prefix + " just joined!  Let's Play!"

                this._gameStartedBg.visible = true;
                this._gameStartedBg.alpha = 0;
                //
                this._versusExplosion.visible = true;
                this._versusExplosion.scale.set( 1, 0 );
                //
                this._versus.visible = true;
                this._versus.scale.set( 0 );
                //
                this._gameReadyTl = new gsap.core.Timeline();
                this._gameReadyTl.to( this._gameStartedBg, { alpha: 1, duration: 1.6, ease: "sine.out" }, 0 );
                this._gameReadyTl.to( this._versusExplosion.scale, { y: 1, duration: 0.8, ease: "expo.out" }, 0 );
                this._gameReadyTl.to( this._versus.scale, { x: 1, y: 1, duration: 1, ease: "back.out" }, 0 );
                this._gameReadyTl.to( this._fadeOutBg, { alpha: 1, duration: 0.4, ease: "linear.inOut" }, ">+2" );
                this._gameReadyTl.call( () => { this._fadeOutBg.visible = true; }, null, "<" );
                this._gameReadyTl.call( () => { this._onCompleted.dispatch( screen_type.GAMEPLAY ); }, null );

                ServiceLocator.audio.playSfx( "matchmaking_found" );
                ServiceLocator.audio.stopMusic();
            }
        }
    }

        private _addBot(): void
        {
            let profile: Profile = { 
                username: { prefix: this._arrBotNames[ Session.i.room.length - 1 ], suffix: Session.i.room.length.toString() },
                avatar: { src: "avatar_" + ( this._arrBotAvatarIndex[ Session.i.room.length - 1 ] ), alt: null } };
            profile.isBot = true;
            Session.i.room.push( profile );
        }

    // #endregion //
}

export interface IStartGamePayload
{
    seed: number,
    room: Array<Profile>
}